<template>
  <div class="order-refund">
    <van-nav-bar title="收款账号" left-arrow @click-left="goBack" />
    <div class="order-refund-detail">
      <van-form @submit="onSubmit">
        <van-field
          :border="false"
          v-model="form.name"
          input-align="right"
          name="name"
          label="持卡人"
          placeholder="请输入持卡人姓名"
          :rules="[{ required: true }]"
        >
        </van-field>
        <p class="order-refund-desc">
          系统只支持退款至游玩人的银行卡号，如有疑问请咨询景区人员并做退款处理！
        </p>
        <van-field
          clickable
          readonly
          :border="false"
          :value="formattedCode"
          input-align="right"
          name="code"
          label="卡号"
          placeholder="请输入卡号"
          @click="showNumberKeyboard = true"
          :rules="[{ required: true }]"
        >
          <!-- <template #right-icon>
            <van-uploader :after-read="scan">
              <svg class="icon icon-photo" aria-hidden="true">
                <use xlink:href="#icon-paizhao"></use></svg
            ></van-uploader>
          </template> -->
        </van-field>
        <van-field
          :border="false"
          input-align="right"
          name="bankName"
          :value="form.bankName"
          label="银行"
          placeholder="请选择银行"
          clickable
          readonly
          @click="showPicker = true"
          :rules="[{ required: true }]"
        >
        </van-field>
        <div class="form-action">
          <van-button
            class="form-btn"
            round
            block
            type="info"
            native-type="submit"
          >
            下一步
          </van-button>
        </div>
      </van-form>
    </div>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="banks"
        value-key="bankName"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>

    <van-number-keyboard
      :show="showNumberKeyboard"
      @blur="showNumberKeyboard = false"
      v-model="form.code"
      maxlength="20"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { Toast } from '@sdi/fish';
import { getBankList } from '@/api';

export default {
  name: 'OrderRefund',
  components: {},
  data: () => ({
    form: {
      bankCode: '',
      bankName: '',
      name: '',
      code: ''
    },
    showPicker: false,
    showNumberKeyboard: false,
    banks: []
  }),
  created() {
    this.form.name = this.$store.state.user.username || '';
    this.initBanks();
  },
  computed: {
    formattedCode() {
      return this.form.code
        .split('')
        .reduce((prev, current, currentIndex) => {
          if (currentIndex % 4 === 0 && currentIndex !== 0) {
            prev.push(' ');
          }
          prev.push(current);

          return prev;
        }, [])
        .join('');
    }
  },
  methods: {
    ...mapActions(['refund', 'getOrderList', 'getOrderListDone']),
    async initBanks() {
      const resp = await getBankList();
      this.banks = +resp.data.status === 200 ? resp.data.data : [];
    },
    goBack() {
      this.$router.back();
    },
    scan(file) {
      console.log(file);
    },
    onConfirm(selected) {
      this.form.bankCode = selected.bankCode;
      this.form.bankName = selected.bankName;
      this.showPicker = false;
    },
    async onSubmit() {
      if (this.form.code.length < 16) {
        Toast('银行卡号不正确');
        return;
      }
      const orderData = this.$store.getters.getOrderById(this.$route.query.id);
      if (!orderData) {
        Toast('订单信息不正确');
        return;
      }
      const success = await this.refund({
        orderData,
        form: this.form
      });
      if (success) {
        await this.getOrderList();
        await this.getOrderListDone();
        this.$router.replace({
          name: 'orderList',
          query: {
            status: 'done'
          }
        });
      }
    }
  }
};
</script>

<style lang="less">
.order-refund {
  background-color: #f7f7f7;
  min-height: 100vh;
  color: #333;
  .van-field {
    margin: 7px 0;
    padding: 13px 14px;
  }
  .van-field__label {
    color: #333;
    font-size: 16px;
  }
  .van-field__control {
    font-size: 16px;
  }
}
.icon-photo {
  color: #333;
  width: 16px;
  height: 13px;
}
.order-refund-desc {
  font-size: 12px;
  color: #999999;
  margin: 10px 15px;
  line-height: 17px;
}
</style>
